import { render, staticRenderFns } from "./TooltipIconBase.vue?vue&type=template&id=4b564b88&scoped=true"
import script from "./TooltipIconBase.vue?vue&type=script&lang=js"
export * from "./TooltipIconBase.vue?vue&type=script&lang=js"
import style0 from "./TooltipIconBase.vue?vue&type=style&index=0&id=4b564b88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b564b88",
  null
  
)

export default component.exports